import React, {Component} from 'react'
import Form from 'procedures/resign/EmployeeForm'
import {connect} from 'react-redux'
import api from 'api'
import {actionCreators} from 'actions'
import withRouterLegacy from 'withRouterLegacy'
import {toFormValues} from 'utils'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'

class Confirm extends Component {
  componentDidMount() {
    const {
      loadProcedureStatus,
      token,
      match: {
        params: {id},
      },
    } = this.props
    loadProcedureStatus(id, token)
  }

  componentWillUnmount() {
    this.props.destroy()
  }

  render() {
    const {
      procedureStatus: {resign_employee_input_datum: inputData, employee},
    } = this.props
    return (
      <Form onSubmit={this.handleSubmit} initialValues={inputData ? toFormValues(inputData) : {}} employee={employee} />
    )
  }

  handleSubmit = (values) => {
    const {updateAndCreateProcedure, token, procedureStatus, history} = this.props
    return updateAndCreateProcedure(procedureStatus, values, token, history)
  }
}

export default withRouterLegacy(
  connect(
    (state) => ({
      token: state.auth.token,
      procedureStatus: state.procedureStatuses.current.data,
    }),
    (dispatch) => ({
      loadProcedureStatus: (id, token) => {
        dispatch(
          actionCreators.procedureStatuses.current.fetchData(
            api.createWithAuth(token).procedureStatuses.get(id, ['resign_employee_input_datum', 'employee'])
          )
        )
      },
      destroy: () => {
        dispatch(actionCreators.procedureStatuses.current.destroy())
      },
      updateAndCreateProcedure: async (procedureStatus, values, token, history) => {
        try {
          await api.createWithAuth(token).procedureStatuses.resignEmployeeInputData.update(procedureStatus.id, values)
          dispatch(notifySuccess('保存しました'))
          history.push(`/procedure_statuses/${procedureStatus.id}`)
        } catch (err) {
          dispatch(asyncError(err))
        }
      },
    })
  )(Confirm)
)
